module.exports = __webpack_public_path__ + "img/040_aussen_thumb.16749e35.jpg";